<template>
  <div>
    <PermissionValidation
      :marketId="marketId"
      rule="enableViewAppeal"
    >
      <ApproveListRenewContract
        :loading="isMainLoading"
        @onInit="getApproveTasksByMarket"
        :approveTasks="approveTasks"
      />
    </PermissionValidation>
  </div>
</template>

<script>
import ApproveListRenewContract from "../../components/ApproveListRenewContract.vue";
import PermissionValidation from "../../components/PermissionValidation.component.vue";
export default {
  components: {
    ApproveListRenewContract,
    PermissionValidation
  },
  props: {
    isMainLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    approveTasks() {
      return this.$store.getters["approveTask/getByType"]("renew_contract");
    }
  },
  data() {
    return {
      marketId: this.$route.params.marketId
    };
  },
  methods: {
    getApproveTasksByMarket() {
      this.$emit("onGetApproveTasksByMarket");
    }
  }
};
</script>